/**
 * Utility per formattazione
 */

/**
 * Formatta secondi in formato mm:ss
 * @param {number} seconds - Secondi da formattare
 * @returns {string} Tempo formattato
 */
export function formatTime(seconds) {
  if (isNaN(seconds)) return '0:00';
  
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Genera ID univoco per istanza
 * @returns {string} ID univoco
 */
export function generateId() {
  return `sasha-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Escape HTML per sicurezza
 * @param {string} str - Stringa da escapare
 * @returns {string} Stringa escapata
 */
export function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

